import axios from '@/requests';
import { ServerInfo, ServerUsage } from '@/store/modules/home/types';
export const homeAPI = {
    async getServerInfo() {
        try {
            const res = await axios.get<ServerInfo[]>('/home/getServerInfo',);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getServerInfoAdded(timeStamp: number) {
        try {
            const res = await axios.get<ServerInfo[]>('/home/getServerInfoAdded', { timeStamp: timeStamp });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getServerUsage() {
        try {
            const res = await axios.get<ServerUsage>('/home/getUsage',);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async checkServerStatus() {
        try {
            const res = await axios.get<ServerInfo>('/home/checkServerStatus',);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getServerInfoByDuration(duration: number) {
        try {
            const res = await axios.get<ServerInfo[]>('/home/getServerInfoByDuration', { duration: duration });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    //
}

